<app-checkin-shell
    [canNext]="canNext"
    [isLastStep]="isLastStep"
    [badgeTemplate]="$safeNavigationMigration(tenantService.currentPointOfService()?.badgeTemplate)"
    [badgeData]="badgeData"
    (back)="goBack()"
    (forward)="goForward()"
    (home)="goHome()"
    (save)="saveCheckin()"
    (badgeImageReady)="onBadgeImageReady($event)">

    @if (editingEntity(); as entity) {

    <!-- STEP 1 unique : Photo + Scan QR employé + Nom + Sélection employé -->
    @if (currentStep() === 1) {
    <div class="flex flex-col items-stretch space-y-4">

        @if (currentPos?.dS_NewEmployee_Camera) {
        <app-photo-capture
            (photoCaptured)="onPhotoCaptured($event)"
            (photoFile)="onEmployeePhotoFile($event)">
        </app-photo-capture>
        }

        @if (showEmployeeQrScanner()) {
        <app-qr-scanner (scanned)="onEmployeeQrScanned($event)"></app-qr-scanner>
        }

        <app-field-wrapper [property]="'visitor.fullname'"
            [label]="'entities.visitor.propreties.fullname'"
            [labelPosition]="'below'"
            [entity]="editingEntity()"
            [isEditMode]="isEditMode()"
            [flashingProperty]="flashingProperty()"
            [index]="getModifiedFieldIndex('visitor.fullname')"
            [totalModified]="totalModifiedCount()"
            [toggleUndo]="toggleUndo.bind(this)"
            [triggerFlash]="triggerFlash.bind(this)"
            [hasValidationErrors]="hasValidationErrors.bind(this)"
            [getValidationErrors]="getValidationErrors.bind(this)"
            [propretyHasChanged]="propretyHasChanged.bind(this)"
            [skin]="Skin">
            <app-multi-select
                [options]="employeeVisitorOptions()"
                [isMultiselect]="false"
                [minChars]="3"
                [allowCreate]="true"
                [skin]="Skin"
                [placeholder]="'Select Employee'"
                [maxItems]="1"
                [selectedKeys]="editingEntity()?.visitor?.selectedPK_Visitor ?? []"
                (selectedKeysChange)="onVisitorSelectChange($event)"
                (createNew)="onCreateVisitor($event)">
            </app-multi-select>
        </app-field-wrapper>

        <app-field-wrapper [property]="'selectedPK_Employee'"
            [labelPosition]="'below'"
            [label]="'entities.visit.propreties.employee'"
            [entity]="editingEntity()"
            [isEditMode]="isEditMode()"
            [flashingProperty]="flashingProperty()"
            [totalModified]="totalModifiedCount()"
            [toggleUndo]="toggleUndo.bind(this)"
            [triggerFlash]="triggerFlash.bind(this)"
            [hasValidationErrors]="hasValidationErrors.bind(this)"
            [getValidationErrors]="getValidationErrors.bind(this)"
            [propretyHasChanged]="propretyHasChanged.bind(this)"
            [skin]="Skin">
            <app-multi-select #multiSelect
                [options]="employeesLookup()"
                [isMultiselect]="false"
                [minChars]="3"
                [skin]="Skin"
                [placeholder]="'Select Employee'"
                [maxItems]="1"
                [selectedKeys]="editingEntity()?.selectedPK_Employee ?? []"
                (selectedKeysChange)="onEmployeeSelectChange($event)"
                onReady
                (autoBind)="bindingHandler($event, 'selectedPK_Employee', multiSelect)">
            </app-multi-select>
        </app-field-wrapper>

    </div>
    }

    <!-- STEP 2 : Politique + Signature -->
    @if (currentStep() === 2) {
    <app-policy-viewer
        [url]="urlPolitique"
        [showSignature]="true"
        (accepted)="onPolicyViewerAccepted($event)"
        (signatureChange)="onSignatureChange($event)">
    </app-policy-viewer>
    }

    <!-- STEP 3 : Engagements -->
    @if (currentStep() === 3) {
    <app-engagement-viewer
        [items]="getEngagementItems()"
        [showSignature]="true"
        [requireSignature]="true"
        (accepted)="onEngagementAccepted($event)"
        (signatureChange)="onSignatureChange($event)">
    </app-engagement-viewer>
    }

    <!-- STEP 4 : Healthy + Signature -->
    @if (currentStep() === 4) {
    <div>
        <app-healthy-viewer
            [items]="getCovidItems()"
            [showSignature]="true"
            [requireSignature]="true"
            (accepted)="onHealthyAccepted($event)"
            (refused)="onHealthyRefused()"
            (signatureChange)="onSignatureChange($event)">
        </app-healthy-viewer>
    </div>
    }

    <!-- STEP 5 : Quiz -->
    @if (currentStep() === 5) {
    <div>
        <app-quiz-viewer
            [items]="getQuizItems()"
            [nbQuestions]="$safeNavigationMigration(currentPos?.quiz_NbQuestion)"
            [random]="currentPos?.quiz_Random ?? false"
            (quizCompleted)="onQuizCompleted($event)">
        </app-quiz-viewer>
    </div>
    }

    }

</app-checkin-shell>